export default __webpack_public_path__ + "static/media/corevalue-challenge.6479da79.png";